import TaskOnDeleteModal from './task-on-delete-modal'
export default TaskOnDeleteModal